module.exports = {"id":"202220","name":"C.J. Sapong","rating":"72","photo":"./data/images/photos/3/202220.png","club":{"name":"Philadelphia U.","logo":"./data/images/clubs/PhiladelphiaU..png"},"positions":["BU"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/C.J.Sapong0.json
// module id = 683
// module chunks = 0